module.exports = __webpack_public_path__ + "img/kkam_gallery0.4d685930.jpg";